export enum UserTypeEnum {
    NULL = '',
    ADMINISTRATOR = 'Amministratore',
    DEVELOPER = 'Sviluppatore',
    LOCKER_MGT = 'Locker MGT',
    LOCKER_WIB = 'Locker WIB',
    SERVER = 'server'
}